export const setCities = (state, cities) => {
  state.cities = cities
}
